export default function(element) {
  const initialDisplay = window.getComputedStyle(element, null).display;
  element.setAttribute("style", "display: none !important");
  return initialDisplay;
}
